import { useEffect, useState } from 'react';
import type { AirportType } from '../utils/types';

type AlphabeticListType = {
  letter: string;
  airports: Array<AirportType>;
};

const useAlphabeticList = (airportsData: Array<AirportType>): Array<AlphabeticListType> => {
  const [list, setList] = useState<Array<AlphabeticListType>>([]);
  useEffect(() => {
    if (airportsData.length > 0) {
      const alphabeticAirportsList = airportsData.reduce(
        (accumulator: Array<AlphabeticListType>, airport: AirportType) => {
          const firstLetter = airport.booking_widget_display_name[0].toLocaleLowerCase();
          if (!accumulator.some((item) => item.letter === firstLetter)) {
            accumulator.push({ letter: firstLetter, airports: [airport] });
          } else {
            const letterObject = accumulator?.find((object) => object.letter === firstLetter);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const letterObjectIndex = accumulator?.indexOf(letterObject!);
            accumulator[letterObjectIndex].airports.push(airport);
          }
          return accumulator;
        },
        [],
      );
      setList(alphabeticAirportsList);
    }
  }, [airportsData]);
  const alphaList = list.sort((a, b) => a.letter.localeCompare(b.letter));
  return alphaList;
};

export default useAlphabeticList;
